import request from '@/utils/request2';
export function mainList(data) {
  return request.post('admin/v2/customer-insurance/list', data);
}
export function delMain(data) {
  return request.post('admin/customer-insurance/delete', data);
}
export function mainStatus(data) {
  return request.post('admin/customer-insurance/status', data);
}
export function mainTop(data) {
  return request.post('admin/customer-insurance/top', data);
}
export function customerInsuranceDetail(data) {
  return request.post('admin/v2/customer-insurance/detail', data);
}
export function editInsurance(data) {
  return request.post('admin/customer-insurance/edit', data);
}
export function templateResources(data) {
  return request.post('admin/customer-insurance/qrcodeTemplate', data);
}
export function generateQrCode(data) {
  return request.post('admin/customer-insurance/generate_qr_code', data);
}
export function generateQrCodeLink(data) {
  return request.post('admin/customer-insurance/generate_qr_code_link', data);
}
export function insuranceContent(data) {
  return request.post('admin/v2/customer-insurance/content', data);
}
export function editCustomerInsurance(data) {
  return request.post('/admin/v2/customer-insurance/edit', data);
}
// 获取二维码模板信息
export function getQrcodeTemplate(data) {
  return request.post('admin/customer-insurance/new_qrcode_template', data);
}
// 获取产品列表模版
export function getTemplateResourceList(data) {
  return request.post('admin/customer-insurance/template_resource', data);
}

//保费模板资源
export function premiumTemplateResource(data) {
  return request.post('admin/v2/customer-insurance/premium-template/resource', data);
}
//保费模板编辑
export function premiumTemplateStore(data) {
  return request.post('admin/v2/customer-insurance/premium-template/store', data);
}